'use client';

import { Compass } from 'lucide-react';
import { useRouter } from 'next/navigation';

import { Button } from '@/components/ui/button';

export function NotFoundContent() {
  const router = useRouter();

  return (
    <div className="w-full max-w-xl animate-fade-in-up" role="alert">
      <div className="text-center space-y-6">
        <div className="flex justify-center mb-4">
          <div className="rounded-full p-5" style={{ backgroundColor: 'var(--primary-40)' }}>
            <Compass
              className="h-10 w-10"
              style={{ color: 'var(--primary-120)' }}
              aria-hidden="true"
            />
          </div>
        </div>

        <div className="space-y-2">
          <h1
            className="text-2xl font-normal font-serif tracking-tight sm:text-3xl text-balance"
            style={{ color: 'var(--text-primary)' }}
          >
            You found the missing page of the story
          </h1>
          <p
            className="text-sm sm:text-base max-w-md mx-auto text-pretty leading-relaxed"
            style={{ color: 'var(--text-secondary)' }}
          >
            There&apos;s nothing here, but your stories are waiting.
          </p>
        </div>

        <div className="flex flex-col items-center gap-3 pt-2">
          <Button variant="primary" size="md" onClick={() => router.push('/')}>
            Back
          </Button>
          <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>
            Need help?{' '}
            <a
              href="mailto:hello@loristry.com"
              className="underline underline-offset-2 hover:opacity-70 transition-opacity"
            >
              Contact support
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
